import { BackofficeCompanyContactsData } from "../store/slices/backoffice/backofficeCompanyContactsSlice";

export function filterContactById(contacts: BackofficeCompanyContactsData[]) {
    const newContacts = contacts?.filter((item) => item.companyContactId)
    return newContacts
}

export function filterContactWithoutId(contacts: BackofficeCompanyContactsData[]) {
    const newContacts = contacts?.filter((item) => !item.companyContactId)
    return newContacts
}

export function filterContactForDelete(contacts: BackofficeCompanyContactsData[], idForDeletion: number | undefined) {
    if(idForDeletion !== undefined){
        const newContacts = contacts?.map((item) => item.companyContactId )
                                    .filter((item) => item === idForDeletion)
        return newContacts
    }
}